import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Badge } from "@vds/badges";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { Modal, ModalTitle, ModalBody } from "@vds/modals";
import { TileContainer } from "@vds/tiles";
import { Title, Body } from "@vds/typography";
import { DeviceContainer } from "./styles";
import './PromoCard.css'

const PromoCardPayOff = ({ aemContent, onClick = () => {} }) => {
  const [showModal, setShowModal] = useState(false);
  const isMobile = useMediaQuery({
    query: "(max-width: 445px)",
  });
  const isXSmall = useMediaQuery({
    query: "(max-width: 400px)",
  });

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  const isPOYDFlowEnabled = window.mbtGlobal.flags.ENABLE_POYD_DIGITAL === "Y"; // This should be replaced with actual logic to determine if POYD flow is enabled
  const aemCTA =
    (isPOYDFlowEnabled ? aemContent?.poydFlowCta : aemContent?.cta) || {};

  return (
    <>
      <CustomDeviceContainer> 
        <Wrapper>
          {!!aemCTA?.isChatIntent && !aemContent?.modal && (
            // if no modal is present, the whole tile can activate chat on click
            <ChatDiv
              id={aemCTA?.isChatIntent ? aemCTA?.link : ""}
              data-lp-link-name={
                aemCTA?.isChatIntent ? aemCTA?.link : ""
              }
            />
          )}
          <TileContainer
            backgroundColor={aemContent?.bgColor ?? "black"}
            padding={isMobile ? "16px 10px 16px 10px" : "24px"}
            onClick={(e) => handleClick(e)}
            width="100%"
            height={"269px"}
          >
            <TileWrapper>
              <TopSection >
                {!!aemContent?.title?.text && (
                    <Title className="responsive-title"
                      color={aemContent?.title?.color ?? "white"}
                      fontWeight={700}
                      bold
                      size="medium"
                    >
                      {aemContent?.title?.text}
                    </Title>
                )}
                {!!aemContent?.content?.text?.length && (
                  <TileContent>
                    <span style={{paddingTop: "8px"}}>
                    {aemContent?.content?.text.map((item, index) => (
                      <Body
                        key={`promo-body-${index}`}
                        size={aemContent?.content?.size ?? "small"}
                        color={aemContent?.content?.color ?? "white"}
                        fontWeight={400}
                      >
                        {item}
                      </Body>
                    ))}
                    </span>
                    {aemContent?.modal?.linkText && (
                      <span className="chatDiv-content" style={
                        isMobile ? {
                        textAlign: "center", justifyContent: 'center', marginTop: '10px'} : {display: 'flex', gap: "10px", flexWrap: 'wrap', wordBreak: 'break-word', 
                        overflowWrap: 'anywhere', whiteSpace: "normal",maxWidth: "100%", textAlign: "left", justifyContent: 'left'}
                        }> 
                        {!!aemCTA && (
                          <BottomSection>
                            {aemCTA?.type === "button" && (
                              <Button
                                size="small"
                                use={aemCTA?.variant ?? "primary"}
                                surface={aemCTA?.surface ?? "dark"}
                                width="fit-content"
                                onClick={(e) => handleClick(e)}
                                style={{backgroundColor: "#ee001e", color: "white"}}
                              >
                                {aemCTA?.text}
                              </Button>
                            )}

                            {!!aemCTA?.isChatIntent && !!aemContent?.modal && (
                              // when modal is present, we need to restrict the chat div to the bottom so that it doesn't cover the modal link
                              <ChatDiv
                                id={
                                  aemCTA?.isChatIntent
                                    ? aemCTA?.link
                                    : ""
                                }
                                data-lp-link-name={
                                  aemCTA?.isChatIntent
                                    ? aemCTA?.link
                                    : ""
                                }
                              />
                            )}
                          </BottomSection>
                        )}
                        <TextLink
                          type="standAlone"
                          size="small"
                          surface={aemContent?.modal?.linkSurface ?? "dark"}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowModal(true);
                          }}
                        >
                          {aemContent?.modal?.linkText}
                        </TextLink>
                      </span>
                    )}
                  </TileContent>
                )}
              </TopSection>
            </TileWrapper>
          </TileContainer>
        </Wrapper>
      </CustomDeviceContainer>
      {!!aemContent?.modal && (
        <Modal opened={showModal} onOpenedChange={setShowModal} 
        >
          <ModalTitle>{aemContent?.modal?.title}</ModalTitle>
          <ModalBody>
            <ModalBodyContent
        style={{ maxHeight: '90vh', scrollBarWidth: 'none', msOverflowStyle: 'none', overflowY: 'auto', overflowX: 'hidden', boxSizing: 'border-box', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
            className="hide-scrollbar" >
              <Body size="large">{aemContent?.modal?.body}</Body>
              <Button
                width={isMobile ? null : "100px"}
                onClick={(e) => setShowModal(false)}
              >
                {aemContent?.modal?.closeButtonText}
              </Button>
            </ModalBodyContent>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

const Wrapper = styled.div`
  height: 100%;
  @media screen and (min-device-width: 768px) {
    :hover {
      transform: scale(1.02);
    }
  }
`;

const CustomDeviceContainer = styled(DeviceContainer)`
height:auto;
min-height: fit-content;
width:100%;

min-width: 0
max-width: 100%

box-sizing: border-box;
display:flex
flex-direction: column
gap: 8px
overflow-wrap: anywhere;
word-break: break-word
@media (max-width:768px){
margin-bottom: 15px
}
@media (max-width: 480px){
.responsive-title{
display: inline-block;
white-space: pre-wrap;
}
margin-bottom: 15px;
}
`
const TileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 290px;
`;

const TileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width:480px){
    display: inline-flex;
    width: 158px;
    text-align: left;
    padding: 0 12px;
  }
`;

const BottomSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  @media (max-width:768px){
    margin-bottom: 15px;
    display: grid;
    margin-bottom: 5px;
    position: relative;
    bottom: 15px;

  }
`;

const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const ChatDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: auto;
`;

export default PromoCardPayOff;
